/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ProjectList
 */
export interface ProjectList {
  /**
   *
   * @type {string}
   * @memberof ProjectList
   */
  readonly url: string;
  /**
   *
   * @type {string}
   * @memberof ProjectList
   */
  slug?: string | null;
  /**
   *
   * @type {string}
   * @memberof ProjectList
   */
  name: string;
}

/**
 * Check if a given object implements the ProjectList interface.
 */
export function instanceOfProjectList(value: object): value is ProjectList {
  if (!("url" in value) || value["url"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function ProjectListFromJSON(json: any): ProjectList {
  return ProjectListFromJSONTyped(json, false);
}

export function ProjectListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectList {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
    slug: json["slug"] == null ? undefined : json["slug"],
    name: json["name"],
  };
}

export function ProjectListToJSON(json: any): ProjectList {
  return ProjectListToJSONTyped(json, false);
}

export function ProjectListToJSONTyped(
  value?: Omit<ProjectList, "url"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    slug: value["slug"],
    name: value["name"],
  };
}
